import React from "react";
import { Container, Accordion } from "react-bootstrap";
import "./Faqs.css";

const Faqs = () => {
  return (
    <>
      <section className="faq-hero">
        <Container>
          <h1>Frequently Asked Questions</h1>
          <p>
            Everything you need to know before planning your travel or corporate program with Plenary Holidays.
          </p>
        </Container>
      </section>

      <section className="faq-section">
        <Container>

          <Accordion flush>

            <h3>I. General & Booking</h3>

            <Accordion.Item eventKey="0">
              <Accordion.Header>
                1. How do we get started with Plenary Holidays?
              </Accordion.Header>
              <Accordion.Body>
                Simply submit an enquiry through our website or email us at mail@plenaryholidays.com.
                <br /><br />
                Our destination specialists will understand your travel objectives, budget, and timelines before sharing a curated itinerary and a transparent quotation within 2 business days.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                2. What makes Plenary Holidays different from other travel agencies?
              </Accordion.Header>
              <Accordion.Body>
                With over 16 years of industry experience and our own corporate headquarters in New Delhi, we offer operational stability, accountability, and structured execution.
                <br /><br />
                Our team provides candid, experience-based advice supported by regular site inspections and active participation in global travel platforms such as SATTE, OTM, and ITB.
                <br /><br />
                We operate with documented confirmations, GST-compliant invoicing, and transparent communication at every stage.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                3. What payment methods do you accept?
              </Accordion.Header>
              <Accordion.Body>
                We accept all professional and corporate payment channels, including:
                <ul>
                  <li>NEFT</li>
                  <li>RTGS</li>
                  <li>IMPS</li>
                  <li>UPI</li>
                  <li>Remittance</li>
                </ul>
                All transactions are supported by official GST-compliant invoices.
              </Accordion.Body>
            </Accordion.Item>

            <h3>II. MICE & Corporate Travel (High Priority)</h3>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                4. Can you handle large-scale corporate groups?
              </Accordion.Header>
              <Accordion.Body>
                Yes. We specialize in managing corporate group movements ranging from executive retreats to large-scale conferences with 500+ delegates.
                <br /><br />
                Our established airline, hotel, and venue partnerships enable seamless coordination, structured logistics, and strict timeline adherence.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>
                5. Do you assist with event production and venue sourcing?
              </Accordion.Header>
              <Accordion.Body>
                Yes. Our MICE division provides end-to-end event management services including:
                <ul>
                  <li>Venue scouting & contract negotiation</li>
                  <li>Stage branding & event production</li>
                  <li>Audio-visual technical coordination</li>
                  <li>Gala dinner planning</li>
                  <li>Team-building and experiential activities</li>
                  <li>On-ground supervision</li>
                </ul>
                We align each program with your business objectives and compliance standards.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5">
              <Accordion.Header>
                6. How do you ensure corporate compliance and safety?
              </Accordion.Header>
              <Accordion.Body>
                As a registered member of GAEHP (Global Association of Events & Hospitality Professionals), we follow structured hospitality and event management protocols.
                <br /><br />
                We prioritize traveler safety, transparent budgeting, vendor due diligence, and clear communication throughout the event lifecycle.
              </Accordion.Body>
            </Accordion.Item>

            <h3>III. On-Trip Experience</h3>

            <Accordion.Item eventKey="6">
              <Accordion.Header>
                7. Will we have support during our travel?
              </Accordion.Header>
              <Accordion.Body>
                Yes. We provide a 24/7 Emergency Support line at +91-9560321110 and assign a dedicated ground coordinator for every group or corporate movement to ensure smooth execution.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7">
              <Accordion.Header>
                8. Can you accommodate special dietary requirements?
              </Accordion.Header>
              <Accordion.Body>
                Yes. We regularly manage diverse dietary needs including Vegetarian, Jain, Vegan, and Gluten-free meals, especially for group travel and corporate buffets.
                <br /><br />
                Special requests should be communicated in advance for proper arrangements.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="8">
              <Accordion.Header>
                9. Will the final trip follow the itinerary exactly?
              </Accordion.Header>
              <Accordion.Body>
                We strive for complete adherence to the confirmed itinerary.
                <br /><br />
                However, in case of unforeseen circumstances such as weather disruptions, local advisories, or safety considerations, our on-ground team may make necessary adjustments in consultation with the traveler or corporate coordinator.
              </Accordion.Body>
            </Accordion.Item>

            <h3>IV. Cancellations & Refunds</h3>

            <Accordion.Item eventKey="9">
              <Accordion.Header>
                10. What is your cancellation policy?
              </Accordion.Header>
              <Accordion.Body>
                Cancellation requests must be submitted in writing via email.
                <br /><br />
                Standard leisure booking cancellation policy:
                <ul>
                  <li>30+ days prior: Communication charges of ₹2,000 per person</li>
                  <li>15–30 days prior: 25% of tour cost</li>
                  <li>07–14 days prior: 50% of tour cost</li>
                  <li>Less than 3 days / No show: 100% of tour cost</li>
                </ul>
                For MICE and group bookings, specific hotel and airline contractual terms will apply.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="10">
              <Accordion.Header>
                11. How long does it take to process a refund?
              </Accordion.Header>
              <Accordion.Body>
                Refunds are processed to the original payment source and typically require up to 15 working days, subject to banking timelines and vendor settlement terms.
              </Accordion.Body>
            </Accordion.Item>

          </Accordion>

          <div className="faq-cta">
            <p>
              Have a specific question not listed here? <a href="/contact">Contact our Experts</a>
            </p>
          </div>

          {/* <div className="faq-extra">
            <p>
              Excellent — this is honest, grounded, and aligned with your business.
              <br /><br />
              Below is your final, professionally structured CSR page, refined for:
              <br />
              • Corporate credibility
              <br />
              • Responsible tourism positioning
              <br />
              • Clear structure & flow
              <br />
              • Alignment with your 16-year legacy
              <br />
              • SEO & AI clarity
              <br />
              • No overstatement
            </p>
          </div> */}

        </Container>
      </section>
    </>
  );
};

export default Faqs;